module.exports = function(){ /* empty */ };


//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js/library/modules/_add-to-unscopables.js
// module id = 70
// module chunks = 0